export class TwoDimensionalMap<T, U, V = void> {
  parentMap: Map<T, Map<U, V>> = new Map();

  add(key1: T, key2: U, value: V) {
    const childMap = this.parentMap.get(key1);
    if (childMap) {
      childMap.set(key2, value);
    } else {
      const newMap = new Map();
      newMap.set(key2, value);
      this.parentMap.set(key1, newMap);
    }
  }

  delete(key1: T, key2: U) {
    const childMap = this.parentMap.get(key1);
    if (!childMap) {
      return;
    }

    childMap.delete(key2);

    if (childMap.size === 0) {
      this.parentMap.delete(key1);
    }
  }

  has(key1: T, key2: U) {
    return Boolean(this.parentMap.get(key1)?.has(key2));
  }

  get(key1: T, key2: U): V | undefined {
    return this.parentMap.get(key1)?.get(key2);
  }

  first(): undefined | [T, U, V] {
    const parentIterator = this.parentMap[Symbol.iterator]();
    const parentResult = parentIterator.next();
    if (parentResult.done) {
      return undefined;
    }

    const [key1, childMap] = parentResult.value;
    const childIterator = childMap[Symbol.iterator]();
    const childResult = childIterator.next();
    if (childResult.done) {
      return undefined;
    }

    const [key2, value] = childResult.value;
    return [key1, key2, value];
  }
}
